import React, { useEffect, useRef, useState } from "react";
import svg91 from "../../assets/svg/svg91.svg";
import svg92 from "../../assets/svg/svg92.svg";
import svg93 from "../../assets/svg/svg93.svg";
import svg94 from "../../assets/svg/svg94.svg";
import svg95 from "../../assets/svg/svg95.svg";
import svg96 from "../../assets/svg/svg96.svg";
import svg97 from "../../assets/svg/svg97.svg";
import { Form, Table } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { fetchData } from "../../features/fetch/fetchSlice";
import CardLoading from "../../components/CardLoading";

function LogsTable({ filters = {} }) {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v2/audit-trail/fetch";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const [searchInput, setsearchInput] = useState(null);

  const columns = [
    {
      title: "Timestamp",
      dataIndex: "date",
      render: (item) => {
        if (!item) return "--";
        return (
          <div className="flex items-center gap-[.5rem] whitespace-nowrap">
            <img src={svg91} alt="svg91" />
            <span className="text-[#101828] text-[0.875rem] font-[500]">
              {moment(item).format("DD-MM-YYYY")} -{" "}
              <span className="text-[#6A7282] text-[0.75rem] font-[400]">
                {moment(item).format("hh:mm A")}
              </span>
            </span>
          </div>
        );
      },
    },
    {
      title: "User",
      dataIndex: "userFullNames",
    },
    {
      title: "Action",
      render: (item) => {
        const actionConfig = {
          INSERT: {
            icon: svg92,
            bg: "#DCFCE7",
            textColor: "#008236",
            label: "Insert",
          },
          READ: {
            icon: svg93,
            bg: "#EFF6FF",
            textColor: "#1447E6",
            label: "Read",
          },
          UPDATE: {
            icon: svg94,
            bg: "#FEF3E2",
            textColor: "#A65F00",
            label: "Update",
          },
          DELETE: {
            icon: svg95,
            bg: "#FFE2E2",
            textColor: "#C10007",
            label: "Delete",
          },
          LOGIN: {
            icon: svg96,
            bg: "#EFF6FF",
            textColor: "#1447E6",
            label: "Login",
          },
          LOGOUT: {
            icon: svg97,
            bg: "#F3E8FF",
            textColor: "#8200DB",
            label: "Logout",
          },
        };
        const config = actionConfig[item?.title];
        if (!config) return item?.title || "--";
        return (
          <div className="flex items-center gap-2 !w-fit">
            <div
              className="flex items-center gap-3 rounded-2xl px-2 py-1 font-[Inter] text-[0.75rem] font-medium leading-[1.125rem]"
              style={{
                backgroundColor: config.bg,
                color: config.textColor,
              }}
            >
              <img src={config.icon} alt={config.label} className="w-3 h-3" />
              <span>{config.label}</span>
            </div>
          </div>
        );
      },
    },
    {
      title: "Table",
      dataIndex: "userFriendlyTableName",
    },
    {
      title: "Record",
      dataIndex: "recordName",
    },
    {
      title: "Description",
      dataIndex: "description", 
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        ...filters,
      }),
    );
  }

  useEffect(() => {
    fetchTableData();
  }, [filters]);

  if (loading && !searchInput) return <CardLoading />;

  return (
    <div className="white_card mt-[1.5rem]">
      <div className="text-[#0A0A0A] text-[1rem] font-[600] leading-[1.5rem]">
        Sysytem Activity Logs
      </div>
      <div className="text-[#6A7282] mt-[.37rem] text-[.875rem] font-[400] font-interSans leading-[1.25rem]">
        Monitor actions, login events, and changes made in the system.
      </div>
      <Table
        rowSelection={false}
        className="mt-[1.5rem] w-full"
        scroll={{
          x: "auto",
        }}
        rowKey={(record) => record?.auditId}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          position: ["bottomRight"],
          current: pageIndex + 1,
          total: count,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPageIndex(page - 1);
            setPageSize(size);
            fetchTableData(page - 1, size);
          },
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
      />
    </div>
  );
}

export default LogsTable;
